export default {
  computed: {
    scopeAttrs(): any {
      // Get the scope attribute name (undefined if none)
      const scopeAttr = (this as any).$parent.$options._scopeId;
      return scopeAttr ? { [scopeAttr]: '' } : {};
    },
  },
};
